export function hasCookiePreferences(): boolean {
	if (typeof window === 'undefined') return false;

	return typeof window.ketch === 'function';
}

export function showCookiePreferences(): void {
	if (!hasCookiePreferences()) return;

	// biome-ignore lint/security/noSecrets: Not a secret
	window.ketch?.('showPreferences', {
		showOverviewTab: false,
	});
}
